// utils/axiosInstance.js
import { getClientId } from "./getclientid";

import axios from "axios";
import { API_URL } from "../apiUrl";

const axiosInstance = axios.create({
  baseURL: `${API_URL}`,
  withCredentials: true, // ✅ IMPORTANT (send/receive cookies)
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    // add client id
    if (typeof window !== "undefined") {
      const cid = getClientId();
      //const cid = getClientId();

      if (cid) config.headers["X-Client-Id"] = cid; // ✅ send header

      const token = localStorage.getItem("token");
      if (token) config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// You can handle response errors globally here as well
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle specific errors (e.g., 401 Unauthorized) or log errors
    if (error.response && error.response.status === 401) {
      // You can implement token expiration handling here
      console.log("Session expired, please log in again");
      // Redirect to login page if necessary
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
